module.exports = __webpack_public_path__ + "img/40.ad9a0b6c.jpg";